'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Portal = require('../Helpers/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overlay = function (_PureComponent) {
  _inherits(Overlay, _PureComponent);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  Overlay.prototype.getChildContext = function getChildContext() {
    // Always want the overlay to render in a separate subtree until 1.1.0
    return { isInPortal: false };
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        visible = _props.visible,
        renderNode = _props.renderNode,
        onClick = _props.onClick,
        style = _props.style,
        className = _props.className;

    return _react2.default.createElement(
      _Portal2.default,
      { visible: visible, renderNode: renderNode },
      _react2.default.createElement('div', {
        style: style,
        className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
          'md-overlay--active': active
        }, className),
        onClick: onClick
      })
    );
  };

  return Overlay;
}(_react.PureComponent);

Overlay.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  visible: _propTypes2.default.bool.isRequired,
  renderNode: _propTypes2.default.object,
  onClick: _propTypes2.default.func
};
Overlay.childContextTypes = {
  isInPortal: _propTypes2.default.bool
};
exports.default = Overlay;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Drawers/Overlay.js
// module id = 236
// module chunks = 79611799117203 213534597649335